/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesEditorAliases {
  ADD_INSTITUTION_STANDARD_TEXT_ACTION = 'add-institution-standard-text-action',
  ADD_MY_STANDARD_TEXT_ACTION = 'add-my-standard-text-action',
  AUTOC_CLINICAL_NOTES_TYPE = 'autoc-clinical-notes-type',
  AUTOC_MEDICAL_SPECIALTY = 'autoc-medical-specialty',
  AUTOC_PERSON = 'autoc-person',
  CLINICAL_NOTES_PANEL_SUCCESS_LOADER = 'clinical-notes-panel-success-loader',
  CONTEXTUAL_BAR_CLINICAL_NOTES_MENU = 'contextual-bar-clinical-notes-menu',
  DELETE_CLINICAL_NOTE_ACTION = 'delete-clinical-note-action',
  FETCH_CLINICAL_NOTES_TYPE = 'fetch-clinical-notes-type',
  FETCH_MEDICAL_SPECIALTY = 'fetch-medical-specialty',
  FETCH_PERSON = 'fetch-person',
  FIELD_CLINICAL_NOTES_TYPE = 'field-clinical-notes-type',
  FIELD_EVOLUTION_DATE = 'field-evolution-date',
  FIELD_EVOLUTION_DESC = 'field-evolution-desc',
  FIELD_MEDICAL_SPECIALTY = 'field-medical-specialty',
  FIELD_MEDICO_PARECER = 'field-medico-parecer',
  FORM_CLINICAL_NOTES = 'form-clinical-notes',
  INACTIVATE_CLINICAL_NOTE_ACTION = 'inactivate-clinical-note-action',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DATETIME = 'input-datetime',
  LAYOUT_CLINICAL_NOTES_EDITOR = 'layout-clinical-notes-editor',
  LOADER_RELEASE_CLINICAL_NOTE = 'loader-release-clinical-note',
  MAPPER_CLINICAL_NOTES_TYPE = 'mapper-clinical-notes-type',
  MAPPER_MEDICAL_SPECIALTY = 'mapper-medical-specialty',
  MAPPER_PERSON = 'mapper-person',
  NEW_CLINICAL_NOTE_ACTION = 'new-clinical-note-action',
  PANEL_HEADER = 'panel-header',
  PANEL_LOAD_RELEASE = 'panel-load-release',
  RELEASE_BUTTON = 'release-button',
  RELEASE_GLOBAL_ACTIONS = 'release-global-actions',
  SUCCESS_LOADER = 'success-loader',
  TEXT_AREA_EVOLUTION_DESC = 'text-area-evolution-desc',
  TEXT_CLINICAL_NOTES_TYPE = 'text-clinical-notes-type',
  TEXT_MEDICAL_SPECIALTY = 'text-medical-specialty',
  TEXT_PERSON = 'text-person',
}
export { ClinicalNotesEditorAliases };
